import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        id          : 0,
        account_id  : 0,
        project_id  : 0,
        feedback_id : 0,
        user_id     : 0,
        created_at  : 0,
    }
});